<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import { formatHours } from '../format.mjs';

  export let bit;
  export let currency;
  export let rates;
  export let hourlyRateMinor;
  export let selected;
  export let onToggle;

  // Only show what this item comes to once the payer has actually chosen a rate.
  // Before that there is no number to show, and rendering $0.00 reads as a price.
  $: hasRate = Number(hourlyRateMinor) > 0;
  $: laborMinor = Math.round(bit.hours * hourlyRateMinor);
  // The public summary contains progress against the published suggestion, not
  // an exact contributed amount or an individual payer's identity.
  $: hasEarlierContributions = !!rates?.hasContributions;
  $: hasPaymentPercent = Number.isFinite(rates?.paymentPercent);
  $: paymentPercent = Number(rates?.paymentPercent) || 0;
</script>

<label class="bit-card selectable work-row" class:chosen={selected}>
  <input checked={selected} type="checkbox" on:change={onToggle} />
  <span class="work-row-body">
    <span class="work-row-head">
      <strong>{bit.label}</strong>
      <span class="figure work-row-hours">{formatHours(bit.hours)}</span>
    </span>
    {#if bit.description}
      <small>{bit.description}</small>
    {/if}
    <small class="work-row-money">
      {#if hasRate}
        <span class="money">{minorToMoney(laborMinor, currency)}</span> at suggested rate
      {:else}
        Set your rate below to see what this comes to
      {/if}
      {#if bit.fixedCostMinor}
        · plus <span class="money">{minorToMoney(bit.fixedCostMinor, currency)}</span> in costs
      {/if}
    </small>
    {#if hasEarlierContributions}
      <small class="work-row-history">
        Payments received{hasPaymentPercent ? ` (${paymentPercent}%)` : ''}
      </small>
    {/if}
  </span>
</label>
